
import { controls } from "../../controls";
const ms232 = {
  label: "Release Lein Marking For Deposit",
  pageLabel: "Release Lein Marking For Deposit",
  starting: true,
  url: "ms232",
  pageType: "history",
  form: [
    ...controls.displayText({ label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ defaultValue: "assigned_branch" }),
    ...controls.showData({ data: "branch_display", name: "branch_display", width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-6" }),
    ...controls.displayText({ star: true, label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ isRequired: true, width: "col-sm-2" }),
    ...controls.showData({ width: "col-sm-2", data: "product_code_display", name: "product_code_display" }),
    ...controls.displayText({ label: "", width: "col-sm-6" }),
    ...controls.displayText({ star: true, label: "Deposite Account Code", width: "col-sm-2" }),
    ...controls.AccountNumber({
      isRequired: true, beforeLeave: ["createAcNo"],
    }),
    ...controls.showData({ data: "account_number_display", width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-6" }),
    ...controls.magicDateLabel({ label: "Date", width: "col-sm-2" }),
    ...controls.magicDate({ dateType: "ontype", name: "date", width: "col-sm-2", default: "sessiondate" }),
    ...controls.displayText({ width: "col-sm-8" }),
    ...controls.magicDateLabel({ label: "Released Date", width: "col-sm-2" }),
    ...controls.magicDate({ dateType: "ontype", name: "released_date", width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-8" }),
  ]
};

export default ms232;
